import { ID_PATTERN } from "@gioia365/contracts";
import { searchParamText } from "../leads/lead-list-hooks";
import type { OpportunitiesRequest } from "./opportunity-queries";

// L'indirizzo della pagina «Opportunità» (piano M6, R8, Task 25; mock-up `opportunita.html`): come vederle («Per fase», di partenza,
// o `vista=tabella`), «Quali» (le aperte, di partenza, o `quali=vendute|perse|tutte`), «Di chi» (`chi`, l'appartenenza di chi la
// segue: vale soltanto per chi le vede tutte), la campagna (`campagna`, il suo nome) e la ricerca (`q`). Così un link o il ritorno
// dalla scheda di un Lead riaprono la stessa vista. I valori di partenza non si scrivono; un valore sconosciuto vale come assente.

/** «Quali»: la parola dell'indirizzo e la fase per il server (`open` le quattro aperte; nessuna, tutte). */
export const WHICH_PARAMS = { aperte: "open", vendute: "sold", perse: "lost", tutte: undefined } as const;
export type WhichParam = keyof typeof WHICH_PARAMS;

export type OpportunitiesSearch = {
  vista?: "tabella";
  quali?: Exclude<WhichParam, "aperte">;
  chi?: string;
  campagna?: string;
  q?: string;
};

/** Il nome di una campagna come lo accetta il server: al più 200 caratteri, mai vuoto. */
const CAMPAIGN_MAX_LENGTH = 200;

/** I parametri dell'indirizzo `/opportunita`: un valore sconosciuto o di forma sbagliata vale come assente. */
export function validateOpportunitiesSearch(search: Record<string, unknown>): OpportunitiesSearch {
  const result: OpportunitiesSearch = {};
  if (search.vista === "tabella") result.vista = "tabella";
  if (search.quali === "vendute" || search.quali === "perse" || search.quali === "tutte") result.quali = search.quali;
  // Un identificativo di sole cifre torna dall'indirizzo come numero (il router legge i valori come JSON).
  const chi = typeof search.chi === "number" && Number.isSafeInteger(search.chi) ? String(search.chi) : search.chi;
  if (typeof chi === "string" && chi !== "all" && ID_PATTERN.test(chi)) result.chi = chi;
  if (typeof search.campagna === "string" && search.campagna.trim() !== "" && search.campagna.length <= CAMPAIGN_MAX_LENGTH) result.campagna = search.campagna;
  const q = searchParamText(search.q);
  if (q !== undefined) result.q = q;
  return result;
}

/**
 * I filtri dell'indirizzo per il server, senza la fase: «Di chi» soltanto per chi vede tutte le Opportunità (agli altri il server lo
 * ignora), campagna e ricerca. La fase la aggiungono la colonna di «Per fase» o «Quali» per la «Tabella» (`WHICH_PARAMS`).
 */
export function opportunitiesFiltersOf(search: OpportunitiesSearch, canFilterByPerson: boolean): OpportunitiesRequest {
  return {
    ...(canFilterByPerson && search.chi !== undefined ? { who: search.chi } : {}),
    ...(search.campagna === undefined ? {} : { campaign: search.campagna }),
    ...(search.q === undefined ? {} : { q: search.q }),
  };
}
